import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/tauchen.jpg"

const Tauchen = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - Tauchentauglichkeitsuntersuchung</h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                    Der Tauchsport bedarf einer gründlichen Untersuchung der körperlichen Fitness.
                    <br /><br />
                    Bis 40 Jahre muss Jede/r alle 2 Jahre zur tauchärztlichen Untersuchung gehen bzw. obliegt es dem Arzt einen anderen Intervall zu empfehlen. Ab 40 Jahre braucht man jährlich eine ärztliche Bestätigung.
                    <br /><br />
                    Neben einer allgemeinen und speziellen tauchmedizinischen Anamnese und Untersuchung des ganzen Körpers sowie Spiegelung des Trommelfells mit Überprüfung der Fähigkeit zum Druckausgleich werden bei der Tauchtauglichkeitsuntersuchung in allen Altersgruppen ein EKG in Ruhe, eine Spirometrie mit Aufzeichnung der Fluss-/Volumenkurve und eine Pulsoxymetrie durchgeführt.
                    <br /><br />
                    Für die Tauchtauglichkeitsuntersuchung bei Personen über 40 Jahren muss eine Ergometrie mit Messung von Blutdruck und EKG unter Belastung durchgeführt werden. Abhängig von der körperlichen Untersuchung, der Anamnese und bestehenden Vorerkrankungen kann eine Blutentnahme sinnvoll sein.
                    <br /><br />
                    Bitte geben Sie schon bei der Terminvereinbarung, bekannt, dass Sie eine Tauchtauglichkeitsuntersuchung wünschen und bringen Sie das Formular "Erklärung zum Gesundheitszustand" schon ausgefüllt mit.
                    <br /><br />
                    Diese Leistung wird nicht von den Krankenkassen honoriert, sondern muss privat bezahlt werden.
                    <br /><br />

                    <h3> Tauchen nach Covid Infection? </h3>
                    Bei einer Infektion mit dem Erreger SARS-CoV2 erlischt zunächst eine vorhandene Tauchtauglichkeit!
                    <br /><br />
                    Ab 4 Wochen nach Testnegativität Untersuchung auf (Wieder)Erteilung der Tauchtauglichkeit möglich. Wenn sich in dieser Untersuchung ein unauffälliger Gesamtbefund ergibt, dann ist wieder uneingeschränkte Tauchtauglichkeit gegeben.
                    <br /><br />
                    Umfang der ärztlichen Diagnostik:
                    Tauchmedizinischer Untersuchungsbogen der GTÜM/ÖGTH
                    <ul>
                        <li>Symptomorientierte Untersuchung</li>
                        <li>Gegebenenfalls weitere Diagnostik wie z.B.:</li>
                        <ul>
                            <li>Ruhe-EKG</li>
                            <li>Einfache Lungenfunktionsuntersuchung (LuFu)</li>
                        </ul>
                    </ul>
                    <br /><br />
                    Je ausgeprägter die Symptome der Sars Covid Infektion waren, umso umfangreicher werden die nachfolgenden Untersuchungen ausfallen
                    <br /><br />
                    Gegebenenfalls weitere Diagnostik wie z.B.
                    <ul>
                        <li>Belastungs-EKG</li>
                        <li>Bodyplethysmographie, DLCO</li>
                        <li>Low-dose HR-CT Thorax (ohne Kontrastmittel)</li>
                        <li>Labor: Routine plus hs-Troponin und NT pro-BNP</li>
                    </ul>
                    Hier Achten auf Post- und ggf. Long-Covid

                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Tauchen;